<template>
  <page-wrapper with-floating-bar>
    <template #title>
      <div class="h3">Новый тарифный план</div>

      <v-spacer />

      <mobile-floating-bar class="d-flex justify-end">
        <e-btn variant="secondary" @click="cancel"> Отмена</e-btn>
        <e-btn variant="primary" class="ml-4" :loading="isLoading" @click="submit"> Создать</e-btn>
      </mobile-floating-bar>
    </template>

    <tariff-form v-model="data" ref="tariffFormRef" />
  </page-wrapper>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import type { TariffFormComponent, TariffFormData } from '@/parts/tariffs/types/tariffs';
import MobileFloatingBar from '@/core/components/common/MobileFloatingBar.vue';
import PageWrapper from '@/core/components/interface/PageWrapper.vue';
import { EBtn } from '@/core/components/ui';
import { RouteNames } from '@/core/plugins/router/routeNames';
import TariffForm from '@/parts/tariffs/components/TariffForm.vue';
import { useTariffsStore } from '@/parts/tariffs/store/tariffs';

const $router = useRouter();
const $route = useRoute();

const { createTariff } = useTariffsStore();

const data = ref<TariffFormData>({
  name: null,
  nds: null,
  penaltyScheme: null,
  supplierPayRules: null,
  stopSalePeriod: 4,
  time: ['PT14H00M', 'PT12H00M'],
  checkOutOnNextDay: true,
});

const cancel = () => {
  $router.back();
};

const tariffFormRef = ref<TariffFormComponent>();

const isLoading = ref(false);

const submit = async () => {
  const payload = tariffFormRef.value?.submit();

  if (!payload) {
    return;
  }

  isLoading.value = true;

  const result = await createTariff(payload);

  if (result?.data?.addTariffSchedule?.tariffScheduleCid) {
    $router.push({
      name: RouteNames.TariffPlacingVariantsMaster,
      params: {
        id: $route.params.id,
        t_id: result.data.addTariffSchedule.tariffScheduleCid,
      },
    });
  }

  isLoading.value = false;
};
</script>
